'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _FormattedJSXMessage = require('I18n/components/FormattedJSXMessage');

var _FormattedJSXMessage2 = _interopRequireDefault(_FormattedJSXMessage);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var MerchandiseIds = _interopRequireWildcard(_MerchandiseIds);

var _Promotions = require('self-service-api/constants/Promotions');

var _ProductsAndPlansNavIds = require('pricing-pages-unified-ui/constants/ProductsAndPlansNavIds');

var _ProductsAndPlansNavIds2 = _interopRequireDefault(_ProductsAndPlansNavIds);

var _urls = require('pricing-pages-unified-ui/utils/urls');

var _PromotionSelectors = require('pricing-pages-unified-ui/selectors/PromotionSelectors');

var _MerchandiseSelectors = require('pricing-pages-unified-ui/selectors/MerchandiseSelectors');

var _PromotionBanner = require('./PromotionBanner');

var _PromotionBanner2 = _interopRequireDefault(_PromotionBanner);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PromotionBannerContainer = function (_React$Component) {
  _inherits(PromotionBannerContainer, _React$Component);

  function PromotionBannerContainer() {
    var _ref, _this$brazilCopyKeyGe;

    var _temp, _this, _ret;

    _classCallCheck(this, PromotionBannerContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PromotionBannerContainer.__proto__ || Object.getPrototypeOf(PromotionBannerContainer)).call.apply(_ref, [this].concat(args))), _this), _this.getBrazilSalesCopyKey = function () {
      var getProductPromotionEligibilityMap = _this.props.getProductPromotionEligibilityMap;


      var starterPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SALES_STARTER);
      var professionalPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SALES_PROFESSIONAL);

      if (starterPromotionEligibilityMap && starterPromotionEligibilityMap.eligiblePromotion === _Promotions.promotionKeys.BRAZIL) {
        return 'sales';
      } else if (professionalPromotionEligibilityMap && professionalPromotionEligibilityMap.eligiblePromotion === _Promotions.promotionKeys.BRAZIL) {
        return 'salesOnlyProfessional';
      }

      return null;
    }, _this.getBrazilServiceCopyKey = function () {
      var getProductPromotionEligibilityMap = _this.props.getProductPromotionEligibilityMap;


      var starterPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SERVICE_STARTER);
      var professionalPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL);

      if (starterPromotionEligibilityMap && starterPromotionEligibilityMap.eligiblePromotion === _Promotions.promotionKeys.BRAZIL) {
        return 'service';
      } else if (professionalPromotionEligibilityMap && professionalPromotionEligibilityMap.eligiblePromotion === _Promotions.promotionKeys.BRAZIL) {
        return 'serviceOnlyProfessional';
      }

      return null;
    }, _this.getBrazilMarketingCopyKey = function () {
      var getProductPromotionEligibilityMap = _this.props.getProductPromotionEligibilityMap;


      var starterPromotionEligibilityMap = getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_MARKETING_STARTER_EMAIL);

      if (starterPromotionEligibilityMap && starterPromotionEligibilityMap.eligiblePromotion === _Promotions.promotionKeys.BRAZIL) {
        return 'marketing';
      }

      return null;
    }, _this.brazilCopyKeyGetterByPageId = (_this$brazilCopyKeyGe = {}, _defineProperty(_this$brazilCopyKeyGe, _ProductsAndPlansNavIds2.default.SALES, _this.getBrazilSalesCopyKey), _defineProperty(_this$brazilCopyKeyGe, _ProductsAndPlansNavIds2.default.SERVICE, _this.getBrazilServiceCopyKey), _defineProperty(_this$brazilCopyKeyGe, _ProductsAndPlansNavIds2.default.MARKETING, _this.getBrazilMarketingCopyKey), _this$brazilCopyKeyGe), _this._getSalesStarterMonthlyDiscountPercentage = function () {
      var _this$props$getProduc = _this.props.getProductPromotionEligibilityMap(MerchandiseIds.PRODUCT_SALES_STARTER),
          monthlyDiscount = _this$props$getProduc.monthlyDiscount;

      return monthlyDiscount;
    }, _this.isInLatamExperimentVariant = function () {
      // All latam-promo-eligible products should have the same discount %
      // so we just use Sales Starter as a proxy
      var discountPercentage = _this._getSalesStarterMonthlyDiscountPercentage();

      var isInLatam = _this.isEligibleForPromotion('LATAM_EXPERIMENT');
      var isDiscountEligible = discountPercentage !== 0;
      var isOnMainHubPage = [_ProductsAndPlansNavIds2.default.SALES, _ProductsAndPlansNavIds2.default.SERVICE, _ProductsAndPlansNavIds2.default.MARKETING].includes(_this.props.hub);

      return isInLatam && isDiscountEligible && isOnMainHubPage;
    }, _this.getLatamDiscountCopyKey = function () {
      // All latam-promo-eligible products should have the same discount %
      // so we just use Sales Starter as a proxy
      var discountPercentage = _this._getSalesStarterMonthlyDiscountPercentage();
      return 'discount' + discountPercentage + 'Percent';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PromotionBannerContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.isEligibleForPromotion('LATAM_EXPERIMENT')) {
        // Fire exposure event for mon150 with the assigned discount
        // B/c auto exposure logging doesn't consider that not all users are latam
        var discount = this._getSalesStarterMonthlyDiscountPercentage();
        (0, _getUsageTracker2.default)().track('publicExperimentExposure', {
          treatmentKey: 'mon150',
          experimentParams: ['discount%-' + discount]
        });
      }
    }
  }, {
    key: 'isEligibleForPromotion',
    value: function isEligibleForPromotion(promotionKey) {
      var _props = this.props,
          products = _props.products,
          eligibleDiscounts = _props.eligibleDiscounts;


      if (!products) return false;

      return eligibleDiscounts.includes(promotionKey);
    }

    /***********************************************/
    /******** MON150 LatAm Experiment Methods ********/
    /***********************************************/

  }, {
    key: 'render',

    /***********************************************/
    /***********************************************/
    /***********************************************/

    value: function render() {
      var _props2 = this.props,
          hasTitleComponent = _props2.hasTitleComponent,
          hub = _props2.hub,
          products = _props2.products;

      if (!products) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        null,
        this.brazilCopyKeyGetterByPageId[hub] && this.brazilCopyKeyGetterByPageId[hub]() && _react2.default.createElement(_PromotionBanner2.default, {
          titleText: _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricingPage.promotions.brazil.' + this.brazilCopyKeyGetterByPageId[hub]() + '.title'
          }),
          bodyText: _react2.default.createElement(_FormattedHTMLMessage2.default, {
            message: 'pricingPage.promotions.brazil.' + this.brazilCopyKeyGetterByPageId[hub]() + '.body'
          }),
          promotion: _Promotions.promotionKeys.BRAZIL,
          dataSelenium: _Promotions.promotionKeys.BRAZIL.toLowerCase() + '-promotion-header',
          hasTitleComponent: hasTitleComponent
        }),
        this.isEligibleForPromotion(_Promotions.promotionKeys.INDIA) && this.props.hub !== 'cms' && _react2.default.createElement(_PromotionBanner2.default, {
          titleText: _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricingPage.promotions.india.title'
          }),
          bodyText: _react2.default.createElement(_FormattedJSXMessage2.default, {
            options: { url: (0, _urls.getIndiaPromotionLandingPageUrl)() },
            elements: { UILink: _UILink2.default },
            message: 'pricingPage.promotions.india.body_jsx'
          }),
          promotion: _Promotions.promotionKeys.INDIA,
          hasTitleComponent: hasTitleComponent
        }),
        this.isEligibleForPromotion(_Promotions.promotionKeys.HSFS_SEED) && _react2.default.createElement(_PromotionBanner2.default, {
          titleText: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.promotions.hsfx.seed.title' }),
          bodyText: _react2.default.createElement(_FormattedJSXMessage2.default, {
            options: { url: (0, _urls.getHSFSPurchaseUrl)() },
            elements: { UIButton: _UIButton2.default },
            message: 'pricingPage.promotions.hsfx.seed.body_jsx'
          }),
          promotion: _Promotions.promotionKeys.HSFS_SEED,
          hasTitleComponent: hasTitleComponent
        }),
        this.isEligibleForPromotion(_Promotions.promotionKeys.HSFX_ENTREPRENEUR) && _react2.default.createElement(_PromotionBanner2.default, {
          titleText: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.promotions.hsfx.entrepreneur.title' }),
          bodyText: _react2.default.createElement(_FormattedJSXMessage2.default, {
            options: { url: (0, _urls.getHSFSPurchaseUrl)() },
            elements: { UIButton: _UIButton2.default },
            message: 'pricingPage.promotions.hsfx.entrepreneur.body_jsx'
          }),
          promotion: _Promotions.promotionKeys.HSFX_ENTREPRENEUR,
          hasTitleComponent: hasTitleComponent
        }),
        this.isEligibleForPromotion(_Promotions.promotionKeys.HSFS_SERIES_A) && _react2.default.createElement(_PromotionBanner2.default, {
          titleText: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.promotions.hsfx.series-a.title' }),
          bodyText: _react2.default.createElement(_FormattedJSXMessage2.default, {
            options: { url: (0, _urls.getHSFSPurchaseUrl)() },
            elements: { UIButton: _UIButton2.default },
            message: 'pricingPage.promotions.hsfx.series-a.body_jsx'
          }),
          promotion: _Promotions.promotionKeys.HSFS_SERIES_A,
          hasTitleComponent: hasTitleComponent
        }),
        this.isInLatamExperimentVariant() && _react2.default.createElement(_PromotionBanner2.default, {
          titleText: _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricingPage.promotions.latam.' + hub + '.' + this.getLatamDiscountCopyKey()
          }),
          bodyText: _react2.default.createElement(_FormattedMessage2.default, {
            message: 'pricingPage.promotions.latam.' + hub + '.body'
          }),
          promotion: 'LATAM_EXPERIMENT',
          hasTitleComponent: false
        })
      );
    }
  }]);

  return PromotionBannerContainer;
}(_react2.default.Component);

PromotionBannerContainer.propTypes = {
  hub: _react.PropTypes.string.isRequired,
  eligibleDiscounts: _react.PropTypes.array.isRequired,
  products: _react.PropTypes.object,
  hasTitleComponent: _react.PropTypes.bool.isRequired,
  getProductPromotionEligibilityMap: _react.PropTypes.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    eligibleDiscounts: (0, _PromotionSelectors.allEligibleDiscountsSelector)(state),
    getProductPromotionEligibilityMap: function getProductPromotionEligibilityMap(merchandiseId) {
      return (0, _PromotionSelectors.merchSpecficPromotionEligibilitySelector)(state, merchandiseId);
    },
    products: (0, _MerchandiseSelectors.merchandiseSelector)(state)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PromotionBannerContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/PromotionBannerContainer.js
// module id = 724
// module chunks = 3 4